import { render, staticRenderFns } from "./MySwitch.vue?vue&type=template&id=7890474a&scoped=true&"
import script from "./MySwitch.vue?vue&type=script&lang=js&"
export * from "./MySwitch.vue?vue&type=script&lang=js&"
import style0 from "./MySwitch.vue?vue&type=style&index=0&id=7890474a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7890474a",
  null
  
)

export default component.exports